import getPerson from './get-person';
import revealPerson from './reveal-person';
import resetButton from './reset-button';
import hidePersonalIdentityNumber from './hide-personal-identity-number';
import resetField from './reset-field';
import resetGFieldError from './reset-gfield-error';

export default async function onInputComplete(input, fieldElement, mask) {
    resultElement = fieldElement.querySelector('.bravo-marknadsinformation-gf__result');
    const isComplete = Inputmask.isValid(input.value, { mask });
    if (isComplete) {
        hidePersonalIdentityNumber(input, fieldElement);
        resetGFieldError(fieldElement);
        resultElement.classList.remove('bravo-marknadsinformation-gf__result--hidden');
        resultElement.classList.add('bravo-marknadsinformation-gf__result--loading');
        const personData = getPerson( input.value, input.dataset.fieldId, input.dataset.formId );
        personData.then( response => {   
            const person = response.data.data.person;
            const output = response.data.data.output;       
            if (!person) {
                console.error('Ingen person hittades', response);
                resetField(fieldElement);
                return;
            } else {
                const validation = document.getElementById( fieldElement.id + '_validation');
                if (validation) {
                    validation.value = '1';
                }
                revealPerson( output, person, input.dataset.formId, resultElement );
                resetButton( fieldElement );
            }
        })
    }
}
